import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import RegisterButton from '../../components/atoms/RegisterButton';
import { getAccounts, addShopAccount } from '../../actions/Accounts';
import { addShopImage, addRelationShop } from '../../actions/Shop';
import '../../stylesheets/csv.css';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  }
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      prefectures: state.commons.prefectures,
      shopCategories: state.commons.shopCategories
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getAccounts, addShopAccount, addShopImage, addRelationShop },
        dispatch
      )
    })
  ),
  withState('listShop', 'setListShop', null),
  withState('listImage', 'setListImage', null),
  withState('listSuccess', 'setListSuccess', null),
  withState('listFalse', 'setListFalse', null),
  withState('groupId1', 'setGroupId1', null),
  withState('groupId2', 'setGroupId2', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
      });
    }
  })
);

const Main = enhance(
  ({
    actions,
    listShop,
    setListShop,
    groupId1,
    setGroupId1,
    groupId2,
    setGroupId2
  }) => {
    const listSuc = [];

    const shopRelationOkAction = async (groupId, shopId) => {
      const params = {
        groupId,
        shopId
      };
      const relationShop = await actions.addRelationShop(params);
      if (relationShop.type === 'ADD_RELATION_SHOP_SUCCESS') {
        return 'ok';
      }
      return '';
    };

    const create = () => {
      let relationShop1 = null;
      let relationShop2 = null;
      let list = [];
      if (listShop.includes(',')) {
        list = listShop.split(',');
      }
      if (list.length > 0) {
        for (let index = 0; index < list.length; index += 1) {
          if (groupId1) {
            relationShop1 = shopRelationOkAction(groupId1, list[index]);
          }
          if (groupId2) {
            relationShop2 = shopRelationOkAction(groupId2, list[index]);
          }
          listSuc.push(
            `${list[index]} ,${relationShop1 ? groupId1 : ''} ,${
              relationShop2 ? groupId2 : ''
            }`
          );
        }
      } else {
        if (groupId1) {
          relationShop1 = shopRelationOkAction(groupId1, listShop);
        }
        if (groupId2) {
          relationShop2 = shopRelationOkAction(groupId2, listShop);
        }
        listSuc.push(
          `${list} ,${relationShop1 ? groupId1 : ''} ,${
            relationShop2 ? groupId2 : ''
          }`
        );
      }
    };

    return (
      <div className="box-create">
        <h2>Tool Relation Shops</h2>
        <br />
        <br />
        <p>Input Group relation shop</p>
        <p>Group 1</p>
        <input
          className="group"
          type="text"
          name="groupId1"
          onChange={e => {
            setGroupId1(e.target.value);
          }}
        />
        <p>Group 2</p>
        <input
          className="group"
          type="text"
          name="groupId2"
          onChange={e => {
            setGroupId2(e.target.value);
          }}
        />
        <p>Shop</p>
        <input
          className="group"
          type="text"
          name="groupId1"
          onChange={e => {
            setListShop(e.target.value);
          }}
        />
        <br />
        <RegisterButton onClickAction={create} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
